import { useAppStore } from '@/hooks'
import { useSelectedBranchNumericId } from '@/pages/User/pages/Home/components/TreePanel/TreePanelContext'
import { useGetNodeDetailUsingGetQuery } from '@/rtkApi'
import {
	isApproverMinimum,
	minimumNumberOfApproversFromJson,
	resolveMinimumNumberOfApprovers,
} from '@/utils/approverMinimum'

/** The system parameter, or 0 when it has never been set. */
export const useMinimumNumberOfApprovers = (systemId?: number): number => {
	const branchId = useSelectedBranchNumericId()
	const fromForm = useAppStore((state) =>
		systemId == null
			? undefined
			: state.system.systems[systemId]?.form.minimumNumberOfApprovers,
	)
	const formHasMinimum = isApproverMinimum(fromForm)
	const { data } = useGetNodeDetailUsingGetQuery(
		{ branchId: branchId ?? 0, structureId: systemId ?? 0 },
		{ skip: systemId == null || branchId == null || formHasMinimum },
	)

	if (formHasMinimum) return fromForm

	const fromStructure = minimumNumberOfApproversFromJson(
		data?.workingData || data?.data,
	)
	return resolveMinimumNumberOfApprovers(fromStructure)
}
